module.exports = "<li ng-if=!activeDataEnvironment.available> <div class=\"alert alert-warning\"> <p>An active account is necessary to access this section</p> </div> </li> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/views/elements/active-account-required-side-menu-notice.html
// module id = 4192
// module chunks = 86